import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/auth/auth.service';

export const authGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const signInPath = '/sign-in';
  const authService = inject(AuthService);
  const router = inject(Router);
  const redirectUrl = router.parseUrl(`${signInPath}?redirectTo=${router.url}`);
  return authService.isAuthenticated.pipe(
    map((isAuthenticated: boolean) => isAuthenticated || redirectUrl)
  );
};
// @Injectable({
//   providedIn: 'root',
// })
// export class AuthGuard {
//   private readonly signInPath = '/sign-in';

//   constructor(
//     private auth: AuthService,
//     private router: Router
//   ) {}

//   canLoad(): Observable<boolean> {
//     return this.auth.isAuthenticated.pipe(first());
//   }

//   canActivate(
//     _: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<true | UrlTree> {
//     return this.redirectIfUnauthenticated(state);
//   }

//   canActivateChild(
//     _: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ): Observable<true | UrlTree> {
//     return this.redirectIfUnauthenticated(state);
//   }

//   private redirectIfUnauthenticated(
//     state: RouterStateSnapshot
//   ): Observable<true | UrlTree> {
//     const redirectUrl = this.router.parseUrl(
//       `${this.signInPath}?redirectTo=${state.url}`
//     );
//     console.log(redirectUrl);
//     return this.auth.isAuthenticated.pipe(
//       map(isAuthenticated => isAuthenticated || redirectUrl)
//     );
//   }
// }
